// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__dDQpp","header":"PatientQuestionnaire_header__2BBV_","info":"PatientQuestionnaire_info__1_kx8"};